module.exports = __webpack_public_path__ + "img/arrive-05ef6a5.jpg";